"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
class MainCacheManager {
  static myInstance = null;
  _config = null;

  /**
   * @returns {MainCacheManager}
   */
  static getInstance() {
    if (MainCacheManager.myInstance === null) {
      MainCacheManager.myInstance = new MainCacheManager();
      MainCacheManager.myInstance.initialize('');
    }
    return this.myInstance;
  }
  constructor() {
    if (MainCacheManager.myInstance) {
      throw new Error("Singleton classes can't be instantiated more than once.");
    }
    MainCacheManager.myInstance = this;
  }
  async initialize(config) {
    this._config = config;
    return this;
  }
  getConfig() {
    return this._config;
  }
}
exports.default = MainCacheManager;